export default "__VITE_ASSET__CAwaik6b__"